<template>
  <div id="app">
    <nprogress-container></nprogress-container>
    <navbar v-if="authenticated" :show="true" v-on:logout="logout"></navbar>
    <router-view class="approot"></router-view>
    <footer-bar v-if="timesheetPage" :show="false"></footer-bar>
  </div>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import { Navbar, Sidebar, AppMain, FooterBar } from 'components/layout/'
import { mapGetters, mapActions } from 'vuex'
import AuthenticationService from './services/authenticationservice'

export default {
  components: {
    Navbar,
    Sidebar,
    AppMain,
    FooterBar,
    NprogressContainer
  },

  beforeMount () {
    const { body } = document
    const WIDTH = 768
    const RATIO = 3

    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let isMobile = rect.width - RATIO < WIDTH
        this.toggleDevice(isMobile ? 'mobile' : 'other')
        this.toggleSidebar(!isMobile)
      }
    }

    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },

  computed: mapGetters({
    sidebar: 'sidebar',
    authenticated: 'authenticated',
    timesheetPage: 'timesheetPage',
    allowanceSwitch: 'allowanceSwitch'
  }),

  methods: {
    ...mapActions([
     'toggleDevice',
     'toggleSidebar'
    ]),

    logout: function () {
      AuthenticationService.logout()
    }
  }
}
</script>

<style lang="scss">
@import '~animate.css';
.animated {
  animation-duration: .377s;
}

@import '~bulma';
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

html {
  background-color: whitesmoke;
}

.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;

  #nprogress {
    $color: #48e79a;

    .bar {
      background: $color;
    }
    .peg {
      box-shadow: 0 0 10px $color, 0 0 5px $color;
    }

    .spinner-icon {
      border-top-color: $color;
      border-left-color: $color;
    }
  }
}

.select .is-danger {
  border-color: #ff3860;
}

.table td {
  word-break: break-word!important;
}
</style>



// WEBPACK FOOTER //
// App.vue?c47ee5f8